import {Link} from '@nlabs/gothamjs/router';

export const SiteFooter = () => (
  <footer className="site-footer">
    <div className="shell footer-grid">
      <div>
        <Link aria-label="Chicago Sentinel Times home" className="masthead masthead--footer" to="/">
          <span aria-hidden="true" className="masthead__mobile"><span>Chicago</span><span>Sentinel Times</span></span>
        </Link>
        <p>Independent metropolitan journalism and civic information for Chicago.</p>
      </div>
      <div>
        <h2>Publication</h2>
        <Link to="/about">About</Link>
        <Link to="/about#standards">Editorial Standards</Link>
        <Link to="/about#contact">Contact</Link>
      </div>
      <div>
        <h2>Transparency</h2>
        <p>The Sentinel includes clearly governed creative editorial material alongside sourced news and public information. It never fabricates real breaking news.</p>
      </div>
    </div>
    <div className="shell footer-bottom">© 2026 Nitrogen Labs <span>Chicago, Illinois</span></div>
  </footer>
);
